import Warenkorb from 'src/pages/Warenkorb/Warenkorb'
import { getSitePageBuilderStaticProps } from 'src/pageBuilder/sitePageBuilder'

export default Warenkorb

export const getStaticProps = getSitePageBuilderStaticProps
